import PayoutReportsListPage from './PayoutReportsListPage';

export default PayoutReportsListPage;
